module.exports = __webpack_public_path__ + "static/media/WRSLOGO.3262be13.png";